<app-loading [active]="loading.isLoading"/>
<app-message [active]="!!errorMsg" [message]="errorMsg"/>

@if (match.isDartsscorer) {
  @if (!loading.isLoading && !errorMsg && statistic) {
    <div class="pb-2 md:pb-0 table-design">
      {{'DATE' | translate}}: {{statistic.date | date: 'dd.MM.yyyy HH:mm'}}<br>
      {{'MODE' | translate}}: {{statistic.startPoints}}
      ({{statistic.doubleIn ? 'Double In/' : ''}}{{statistic.doubleOut ? 'Double Out' : ''}}{{statistic.masterOut ? 'Master Out' : ''}})<br>
      {{'DURATION' | translate}}: {{statistic.duration | durationPipe: false: false}}

      <h3 *ngIf="anyScorePlus">Scoring</h3>
      <div *ngIf="anyScorePlus" class="flex flex-row">
        <table>
          <tr>
            <th></th>
            <th class="col-value">
              60+
            </th>
            <th class="col-value">
              80+
            </th>
            <th class="col-value" *ngIf="scoringDetails" @flyInOutVertical>
              90+
            </th>
            <th class="col-value">
              100+
            </th>
            <th class="col-value" *ngIf="scoringDetails" @flyInOutVertical>
              130+
            </th>
            <th class="col-value">
              140+
            </th>
            <th class="col-value" *ngIf="scoringDetails" @flyInOutVertical>
              170+
            </th>
            <th class="col-value">
              180
            </th>
          </tr>
          @if (statisticMatchListSinglePlayers?.length > 0) {
            <tr *ngFor="let item of statisticMatchListSinglePlayers"
                [class.border-separator]="item.playerIndex > 0 && item.playerPosition === 0">
              <td>
                {{item.displayName ?? getPlayername(item)}}
              </td>
              <td class="text-right col-value">
                {{item.count60}}
              </td>
              <td class="text-right col-value">
                {{item.count80 + (scoringDetails ? 0 : item.count90)}}
              </td>
              <td class="text-right col-value" *ngIf="scoringDetails" @flyInOutVertical>
                {{item.count90}}
              </td>
              <td class="text-right col-value">
                {{item.count100 + (scoringDetails ? 0 : item.count130)}}
              </td>
              <td class="text-right col-value" *ngIf="scoringDetails" @flyInOutVertical>
                {{item.count130}}
              </td>
              <td class="text-right col-value">
                {{item.count140 + (scoringDetails ? 0 : item.count170)}}
              </td>
              <td class="text-right col-value" *ngIf="scoringDetails" @flyInOutVertical>
                {{item.count170}}
              </td>
              <td class="text-right col-value">
                {{item.count180}}
              </td>
            </tr>
          } @else {
            <tr *ngFor="let item of statisticMatchList"
                [class.border-separator]="item.playerIndex > 0 && item.playerPosition === 0">
              <td>
                {{item.displayName ?? getPlayername(item)}}
              </td>
              <td class="text-right col-value">
                {{item.count60}}
              </td>
              <td class="text-right col-value">
                {{item.count80 + (scoringDetails ? 0 : item.count90)}}
              </td>
              <td class="text-right col-value" *ngIf="scoringDetails" @flyInOutVertical>
                {{item.count90}}
              </td>
              <td class="text-right col-value">
                {{item.count100 + (scoringDetails ? 0 : item.count130)}}
              </td>
              <td class="text-right col-value" *ngIf="scoringDetails" @flyInOutVertical>
                {{item.count130}}
              </td>
              <td class="text-right col-value">
                {{item.count140 + (scoringDetails ? 0 : item.count170)}}
              </td>
              <td class="text-right col-value" *ngIf="scoringDetails" @flyInOutVertical>
                {{item.count170}}
              </td>
              <td class="text-right col-value">
                {{item.count180}}
              </td>
            </tr>
          }
        </table>

        <p-button [icon]="scoringDetails ? 'pi pi-chevron-circle-left' : 'pi pi-chevron-circle-right'"
                  styleClass="p-button-rounded p-button-text ml-2 p-button-primary"
                  [pTooltip]="scoringDetails ? 'Weniger Details' : 'Mehr Details'" [showDelay]="400"
                  (click)="scoringDetails = !scoringDetails"/>
      </div>

      <h3>Averages</h3>
      <div>
        <table>
          <tr>
            <th></th>
            <th class="text-center pl-2 pr-2">
              Avg
            </th>
            <th class="text-center pl-2 pr-2">
              First 9D
            </th>
            <th class="text-center pl-2 pr-2">
              First 12D
            </th>
            <th class="text-center pl-2 pr-2">
              First 15D
            </th>
            <th class="text-center pl-2 pr-2">
              First 18D
            </th>
          </tr>

          @for (item of statisticMatchList; track i; let i = $index) {
            <tr [class.border-separator]="item.playerIndex > 0 && item.playerPosition === 0">
              <td>
                {{item.displayName ?? getPlayername(item)}}
              </td>
              <td class="text-right col-value">
                {{item.scoreTotal | averagePipe: item.dartsTotal}}
              </td>
              <td class="text-right col-value">
                {{item.scoreFirst9 | averagePipe: item.dartsFirst9}}
              </td>
              <td class="text-right col-value">
                {{item.scoreFirst12 | averagePipe: item.dartsFirst12}}
              </td>
              <td class="text-right col-value">
                {{item.scoreFirst15 | averagePipe: item.dartsFirst15}}
              </td>
              <td class="text-right col-value">
                {{item.scoreFirst18 | averagePipe: item.dartsFirst18}}
              </td>
            </tr>
          }

          @if (statisticMatchListSinglePlayers?.length > 0) {
            <div>
              <p-button styleClass="p-button-rounded p-button-text ml-2 p-button-primary"
                        [label]="'INDIVIDUAL_PLAYERS' | translate"
                        [icon]="individualPlayersAvgDetails ? 'pi pi-chevron-circle-left' : 'pi pi-chevron-circle-right'"
                        (click)="individualPlayersAvgDetails = !individualPlayersAvgDetails"/>
            </div>

            @if (individualPlayersAvgDetails) {
              @for (item of statisticMatchListSinglePlayers; track i; let i = $index) {
                <tr [class.border-separator]="item.playerIndex > 0 && item.playerPosition === 0">
                  <td>
                    {{item.displayName ?? getPlayername(item)}}
                  </td>
                  <td class="text-right col-value">
                    {{item.scoreTotal | averagePipe: item.dartsTotal}}
                  </td>
                  <td class="text-right col-value">
                    {{item.scoreFirst9 | averagePipe: item.dartsFirst9}}
                  </td>
                  <td class="text-right col-value">
                    {{item.scoreFirst12 | averagePipe: item.dartsFirst12}}
                  </td>
                  <td class="text-right col-value">
                    {{item.scoreFirst15 | averagePipe: item.dartsFirst15}}
                  </td>
                  <td class="text-right col-value">
                    {{item.scoreFirst18 | averagePipe: item.dartsFirst18}}
                  </td>
                </tr>
              }
            }
          }
        </table>
      </div>

      <div *ngIf="statisticsCalculated">
        <h3>Darts/Leg</h3>
        <table>
          <tr *ngIf="setList && setList.length > 1">
            <th>Set</th>
            <th class="text-center pl-2 pr-2" *ngFor="let set of setList" [colSpan]="set.numberOfLegs">
              {{(set.set + 1)}}
            </th>
          </tr>
          <tr>
            <th>Leg</th>
            <th class="text-center pl-2 pr-2" *ngFor="let legStatistic of statisticLegList[0]">
              {{(legStatistic.legIndex + 1)}}
            </th>
          </tr>

          <tr *ngFor="let item of statisticLegList; let i = index"
              [class.border-separator]="item[0].playerIndex > 0 && item[0].playerPosition === 0">
            <td>
              {{item[0]?.displayName ?? getPlayername(item[0])}}
            </td>
            <td class="text-center pl-2 pr-2" *ngFor="let legStatistic of item">
              @if (legStatistic.won) {
                <span [class.underline]="legStatistic.isBreak"
                      [pTooltip]="legStatistic.isBreak ? 'Break' : ''" showDelay="400">
                  {{legStatistic.dartsTotal}}
                </span>
              } @else {
                <span class="text-gray-500"
                      [pTooltip]="'REMAINING_POINTS' | translate" showDelay="400">
                  {{'(' + (legStatistic.startPoints - legStatistic.scoreTotal) + ')'}}
                </span>
              }

              @if (legStatistic.won && legStatistic.scoreTotal !== legStatistic.startPoints) {
                <sup [pTooltip]="'STATISTIC_BULL_SHOOTOUT_HELP' | translate" showDelay="400">
                  *B
                </sup>
              }
            </td>
          </tr>
        </table>

        <h3>Averages/Leg</h3>
        <table>
          <tr *ngIf="setList && setList.length > 1">
            <th>Set</th>
            <th class="text-center pl-2 pr-2" *ngFor="let set of setList" [colSpan]="set.numberOfLegs">
              {{(set.set + 1)}}
            </th>
          </tr>
          <tr>
            <th>Leg</th>
            <th class="text-center pl-2 pr-2" *ngFor="let legStatistic of statisticLegList[0]">
              {{(legStatistic.legIndex + 1)}}
            </th>
          </tr>
          <tr *ngFor="let item of statisticLegList; let i = index"
              [class.border-separator]="item[0].playerIndex > 0 && item[0].playerPosition === 0">
            <td>
              {{item[0]?.displayName ?? getPlayername(item[0])}}
            </td>
            <td class="text-center  pl-2 pr-2" *ngFor="let legStatistic of item">
            <span [class.underline]="legStatistic.won"
                  [pTooltip]="legStatistic.won ? ('WON' | translate) : ''" showDelay="400">
              {{legStatistic.scoreTotal | averagePipe: legStatistic.dartsTotal}}
            </span>
              <sup *ngIf="legStatistic.won && legStatistic.scoreTotal !== legStatistic.startPoints"
                   [pTooltip]="'STATISTIC_BULL_SHOOTOUT_HELP' | translate" showDelay="400">
                *B
              </sup>
            </td>
          </tr>

          @if (statisticLegListSinglePlayers?.length > 0) {
            <div>
              <p-button styleClass="p-button-rounded p-button-text ml-2 p-button-primary"
                        [label]="'INDIVIDUAL_PLAYERS' | translate"
                        [icon]="individualPlayersAvgPerLegDetails ? 'pi pi-chevron-circle-left' : 'pi pi-chevron-circle-right'"
                        (click)="individualPlayersAvgPerLegDetails = !individualPlayersAvgPerLegDetails"/>
            </div>

            @if (individualPlayersAvgPerLegDetails) {
              <tr *ngFor="let item of statisticLegListSinglePlayers; let i = index"
                  [class.border-separator]="item[0].playerIndex > 0 && item[0].playerPosition === 0">
                <td>
                  {{item[0]?.displayName ?? getPlayername(item[0])}}
                </td>
                <td class="text-center  pl-2 pr-2" *ngFor="let legStatistic of item">
                  <span [class.underline]="legStatistic.won"
                        [pTooltip]="legStatistic.won ? ('WON' | translate) : ''" showDelay="400">
                    {{legStatistic.scoreTotal | averagePipe: legStatistic.dartsTotal}}
                  </span>
                  <!-- Kann hier so nicht bestimmt werden da einzelne Würfe nicht 501 (Startpunkte) ergeben
                   <sup *ngIf="legStatistic.won && legStatistic.scoreTotal !== legStatistic.startPoints"
                       [pTooltip]="'STATISTIC_BULL_SHOOTOUT_HELP' | translate" showDelay="400">
                    *B
                  </sup>-->
                </td>
              </tr>
            }
          }
        </table>

        @if (checkoutRate) {
          <h3>{{ 'CHECKOUT_RATE' | translate }}</h3>
          <table>
            @if (setList?.length > 1) {
              <tr>
                <th>Set</th>
                @for (set of setList; track i; let i = $index) {
                  <th class="text-center pl-2 pr-2" [colSpan]="set.numberOfLegs">
                    {{(set.set + 1)}}
                  </th>
                }
              </tr>
            }
            <tr>
              <th>Leg</th>
              @if (!(setList?.length > 1)) {
                <th class="text-center pl-2 pr-2">
                  {{ 'TOTAL' | translate }}
                </th>
              }
              @for (legStatistic of statisticLegList[0]; track i; let i = $index) {
                <th class="text-center pl-2 pr-2">
                  {{(legStatistic.legIndex + 1)}}
                </th>
              }
            </tr>
            @if (statisticLegListSinglePlayers?.length > 0) {
              @for (item of statisticLegListSinglePlayers; track i; let i = $index) {
                <tr [class.border-separator]="item[0].playerIndex > 0 && item[0].playerPosition === 0">
                  <td>
                    {{item[0]?.displayName ?? getPlayername(item[0])}}
                  </td>
                  <td class="text-center pl-2 pr-2 font-bold">
                    {{ statisticMatchListSinglePlayers[i].checkDarts | checkoutPipe: statisticMatchListSinglePlayers[i].checkCount : 1 }}
                  </td>
                  @for (legStatistic of item; track j; let j = $index) {
                    <td class="text-center px-2"
                        [class.underline]="legStatistic.isBreak"
                        [pTooltip]="legStatistic.isBreak ? 'Break' : ''" [showDelay]="400">
                      {{ legStatistic.checkDarts | checkoutPipe: (legStatistic.checkCount ? 1 : 0) : 1}}
                    </td>
                  }
                </tr>
              }
            } @else {
              @for (item of statisticLegList; track i; let i = $index) {
                <tr [class.border-separator]="item[0].playerIndex > 0 && item[0].playerPosition === 0">
                  <td>
                    {{item[0]?.displayName ?? getPlayername(item[0])}}
                  </td>
                  <td class="text-center pl-2 pr-2 font-bold">
                    {{ statisticMatchList[i].checkDarts | checkoutPipe: statisticMatchList[i].legCount : 1 }}
                  </td>
                  @for (legStatistic of item; track j; let j = $index) {
                    <td class="text-center px-2"
                        [class.underline]="legStatistic.isBreak"
                        [pTooltip]="legStatistic.isBreak ? 'Break' : ''" [showDelay]="400">
                      {{ legStatistic.checkDarts | checkoutPipe: (legStatistic.won && legStatistic.scoreTotal === legStatistic.startPoints ? 1 : 0) : 1}}
                    </td>
                  }
                </tr>
              }
            }
          </table>
        }

        <h3>Checkouts/Leg</h3>
        <table>
          @if (setList?.length > 1) {
            <tr>
              <th>Set</th>
              <th class="text-center pl-2 pr-2" *ngFor="let set of setList" [colSpan]="set.numberOfLegs">
                {{(set.set + 1)}}
              </th>
            </tr>
          }
          <tr>
            <th>Leg</th>
            <th class="text-center pl-2 pr-2" *ngFor="let legStatistic of statisticLegList[0]">
              {{(legStatistic.legIndex + 1)}}
            </th>
          </tr>
          <tr *ngFor="let item of statisticLegList; let i = index"
              [class.border-separator]="item[0].playerIndex > 0 && item[0].playerPosition === 0">
            <td>
              {{item[0]?.displayName ?? getPlayername(item[0])}}
            </td>
            <td class="text-center  pl-2 pr-2" *ngFor="let legStatistic of item">
              @if (legStatistic.won && legStatistic.scoreTotal === legStatistic.startPoints) {
                <span [class.underline]="legStatistic.isBreak" [pTooltip]="legStatistic.isBreak ? 'Break' : ''" showDelay="400">
                {{legStatistic.checkoutMax}}
              </span>
              } @else {
                <span>
                -
              </span>
              }
            </td>
          </tr>
        </table>

        <div class="font-italic gray mt-3">
          *{{'STATISTIC_BREAK_HELP' | translate}}
        </div>
        @if (anyBullShootout) {
          <div class="font-italic gray mt-1">
            *B:&nbsp;{{'STATISTIC_BULL_SHOOTOUT_HELP' | translate}}
          </div>
        }
      </div>
    </div>
  } @else {
    <div class="font-italic">
      {{'NO_STATISTICS' | translate}}
    </div>
  }
} @else {
  <div class="font-italic">
    {{'NO_STATISTICS' | translate}}
  </div>
}
